import { uploadFile } from "@shared/blobstorage";
import { useSasToken } from "@shared/hooks/useSasToken";
import { Formik, FormikHelpers } from "formik";
import React, { useState } from "react";
import { useGifMessage } from "@features/upload/useGifMessage";
import { isValidDomain } from "@features/collage/util";
import BootstrapForm from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

interface FormState {
  url?: string;
  file?: File;
}

const Form: React.FC<{ className: string }> = ({ className }) => {
  const [isFileUpload, setFileUploadForm] = useState(false);
  const sasToken = useSasToken();
  const { sendGif } = useGifMessage();

  const validate = (values: FormState) => {
    const errors: Record<string, string> = {};
    if (!isFileUpload && values.url) {
      if (!isValidDomain(values.url)) errors.url = "Invalid URL";
      if (!values.url.includes(".gif"))
        errors.url = "Input supports .gif format only";
    }
    return errors;
  };

  const onSubmit = (
    values: FormState,
    { setSubmitting }: FormikHelpers<FormState>
  ) => {
    if (isFileUpload) {
      setTimeout(async () => {
        if (sasToken && values.file) await uploadFile(sasToken, values.file);
        setSubmitting(false);
      }, 400);
    } else {
      setTimeout(async () => {
        if (values.url) await sendGif(values.url);
        setSubmitting(false);
      }, 400);
    }
  };

  return (
    <Formik<FormState>
      initialValues={{
        url: "",
      }}
      validate={validate}
      onSubmit={onSubmit}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <BootstrapForm className={className} onSubmit={handleSubmit}>
          <BootstrapForm.Group className="mb-3" controlId="formBasicCheckbox">
            <BootstrapForm.Check
              type="checkbox"
              label="Use File Upload"
              name="upload"
              onChange={(event) => {
                handleChange(event);
                setFileUploadForm(event.target.checked);
              }}
              onBlur={handleBlur}
              checked={isFileUpload}
            />
          </BootstrapForm.Group>
          <br />
          {isFileUpload && (
            <BootstrapForm.Group className="mb-3">
              <BootstrapForm.Label htmlFor="file">
                Upload file
              </BootstrapForm.Label>
              <input
                type="file"
                name="file"
                required={isFileUpload}
                onChange={({ target: { files } }) => {
                  if (files && files.length) setFieldValue("file", files[0]);
                }}
                onBlur={handleBlur}
                accept="image/gif"
              />
            </BootstrapForm.Group>
          )}
          {!isFileUpload && (
            <BootstrapForm.Group className="mb-3">
              <BootstrapForm.Label>Enter URL</BootstrapForm.Label>
              <BootstrapForm.Control
                type="url"
                name="url"
                required={!isFileUpload}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.url}
                placeholder="Gif URL"
              />
            </BootstrapForm.Group>
          )}
          {errors.url && touched.url && errors.url}
          <Button type="submit" disabled={isSubmitting}>
            Submit
          </Button>
        </BootstrapForm>
      )}
    </Formik>
  );
};

export default Form;
